import { PalletCapacityDto } from './pallet-capacity-dto';
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class PalletCapacityResponseModel extends GlobalResponseObject{
    data?: PalletCapacityDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //PalletCapacityDto
     */
     constructor(status: boolean, errorCode: number, internalMessage: string, data?: PalletCapacityDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
